import { render, staticRenderFns } from "./zixun.vue?vue&type=template&id=8b16cc36&scoped=true&"
import script from "./zixun.vue?vue&type=script&lang=js&"
export * from "./zixun.vue?vue&type=script&lang=js&"
import style0 from "./zixun.vue?vue&type=style&index=0&id=8b16cc36&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b16cc36",
  null
  
)

component.options.__file = "zixun.vue"
export default component.exports